// extracted by mini-css-extract-plugin
var _1 = "_branchesApprovalTableSearchAndFilterBar-module__content-container";
var _2 = "_branchesApprovalTableSearchAndFilterBar-module__dropdown";
export { _1 as "content-container", _2 as "dropdown" }
